/**
 * web-hero.js — esperienza desktop della home (stile Netflix).
 *
 * Caricato SOLO dalla shell PHP (window.TY_WEB), DOPO web-home.js.
 * Su desktop (>=992px) sostituisce i renderer di header_slideshow_* e
 * collection_spotlight con un hero cinematografico, aggiunge la preview
 * on-hover con trailer alle card collection delle rail e le frecce ai
 * carousel. STESSI DATI del nativo (json.endpoint, /v2/collections/{id});
 * il trailer è l'iframe del player same-origin come nella webapp
 * (muted=on&controls=off&preview=on&auto=on), ma volume e controlli sono
 * gestiti da UN SOLO punto (TyHero): stato muted globale persistito, mai
 * due video in play insieme, pausa fuori viewport, reset al cambio slide.
 */

/* ------------------------------------------------------------------ *
 * TyHero — trailer manager (volume/controlli centralizzati)
 * ------------------------------------------------------------------ */
var TyHero = (function () {
    var muted = true;
    try { muted = localStorage.getItem('ty_home_muted') !== '0'; } catch (e) {}
    var heroes = [];

    function frameUrl(trailerId) {
        return window.location.origin + '/video/player?w=' + trailerId +
            '&muted=on&controls=off&preview=on&auto=on&fillsize=on';
    }

    function video(root) {
        try {
            var f = root.querySelector('iframe.ty-hero-frame');
            if (!f) return null;
            return $(f).contents().find('video')[0] || null;
        } catch (e) { return null; }
    }

    // iframe creato al primo bisogno (lazy): niente N player al boot
    function ensureFrame(root) {
        if (!root || root.querySelector('iframe.ty-hero-frame')) return;
        var trailerId = root.getAttribute('data-trailer');
        if (!trailerId) return;
        var f = document.createElement('iframe');
        f.className = 'ty-hero-frame';
        f.setAttribute('allow', 'autoplay');
        f.setAttribute('scrolling', 'no');
        f.src = frameUrl(trailerId);
        root.querySelector('.ty-hero-media').appendChild(f);
        // quando il video dentro l'iframe parte davvero, fade sull'immagine
        var tries = 0;
        (function waitPlaying() {
            var v = video(root);
            if (v) {
                v.muted = true;
                v.addEventListener('timeupdate', function onT() {
                    if (v.currentTime > 0.15) {
                        root.classList.add('ty-hero-playing');
                        v.removeEventListener('timeupdate', onT);
                    }
                });
                v.addEventListener('ended', function () {
                    root.classList.remove('ty-hero-playing');
                });
            } else if (++tries < 100) {
                setTimeout(waitPlaying, 150);
            }
        })();
    }

    function pauseOthers(except) {
        heroes.forEach(function (r) {
            if (r === except) return;
            var v = video(r);
            if (v) { try { v.pause(); v.muted = true; } catch (e) {} }
        });
    }

    var currentRoot = null;

    function play(root) {
        ensureFrame(root);
        pauseOthers(root);
        currentRoot = root;
        glowSwitchTo(root);
        var v = video(root);
        if (v) {
            try { v.play(); v.muted = muted; } catch (e) {}
        }
    }

    function pause(root) {
        var v = video(root);
        if (v) { try { v.pause(); v.muted = true; } catch (e) {} }
    }

    function icons() {
        $('.ty-hero-vol').html(muted ? '<i class="ri-volume-mute-fill"></i>' : '<i class="ri-volume-up-fill"></i>');
    }

    function toggleMute(btn) {
        muted = !muted;
        try { localStorage.setItem('ty_home_muted', muted ? '1' : '0'); } catch (e) {}
        var root = btn.closest('.ty-hero');
        heroes.forEach(function (r) {
            var v = video(r);
            if (!v) return;
            if (r === root && !muted) {
                try { v.play(); v.muted = false; } catch (e) {}
            } else {
                v.muted = true;
            }
        });
        icons();
    }

    function replay(btn) {
        var root = btn.closest('.ty-hero');
        ensureFrame(root);
        var v = video(root);
        if (v) { try { v.currentTime = 0; v.play(); v.muted = muted; } catch (e) {} }
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var root = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                play(root);
            } else {
                pause(root);
            }
        });
    }, { threshold: [0, 0.5, 1] });

    function register(root) {
        if (!root || heroes.indexOf(root) !== -1) return;
        heroes.push(root);
        if (root.getAttribute('data-trailer')) {
            observer.observe(root);
        }
        icons();
    }

    // cambio slide: reset e riparte solo la slide visibile (parità webapp)
    function bindSlider(sliderEl) {
        try {
            swiffyslider.onSlideEnd(sliderEl, function () {
                setTimeout(function () {
                    $(sliderEl).find('.ty-hero').each(function () {
                        var visible = $(this).closest('.slide-visible').length > 0;
                        var v = video(this);
                        if (visible) {
                            currentRoot = this;
                            glowSwitchTo(this); // il cinema-light segue la slide
                            ensureFrame(this);
                            if (v) { try { v.currentTime = 0; v.play(); v.muted = muted; } catch (e) {} }
                        } else if (v) {
                            try { v.pause(); v.muted = true; } catch (e) {}
                        }
                    });
                }, 200);
            });
        } catch (e) {}
    }

    /* --- cinema light: glow ambientale dietro l'hero ---
       Stessa tecnica della pagina collection (startAmbientCanvasGlow in
       live.js): due canvas in crossfade campionano il video ogni 3s;
       finché il video non gira fa da glow l'immagine di sfondo. Qui il
       video sta nell'iframe same-origin, quindi il campionamento usa
       l'accessor video() di TyHero. */

    // al cambio slide/hero il glow torna all'immagine della slide corrente
    function glowSwitchTo(root) {
        var wrap = root && root.closest('.ty-hero-wrap');
        if (!wrap) return;
        var img = wrap.querySelector('.ty-hero-glow');
        var backdrop = root.getAttribute('data-backdrop');
        if (img && backdrop && img.getAttribute('src') !== backdrop) {
            img.setAttribute('src', backdrop);
        }
        if (img) img.style.opacity = '';
        wrap.querySelectorAll('.ty-hero-glow-canvas').forEach(function (c) {
            c.style.opacity = 0;
        });
        wrap.removeAttribute('data-glow-front');
    }

    setInterval(function () {
        var root = currentRoot;
        if (!root || !document.body.contains(root)) return;
        var wrap = root.closest('.ty-hero-wrap');
        if (!wrap) return;
        var canvases = wrap.querySelectorAll('.ty-hero-glow-canvas');
        var v = video(root);
        if (canvases.length < 2 || !v || v.paused || v.readyState < 2) return;
        try {
            var front = parseInt(wrap.getAttribute('data-glow-front'), 10);
            if (isNaN(front)) front = -1;
            var next = (front === 0) ? 1 : 0;
            var ctx = canvases[next].getContext('2d');
            ctx.drawImage(v, 0, 0, canvases[next].width, canvases[next].height);
            canvases[next].style.opacity = ''; // sfuma verso l'opacità della classe
            if (front >= 0) canvases[front].style.opacity = 0;
            wrap.setAttribute('data-glow-front', next);
            var img = wrap.querySelector('.ty-hero-glow');
            if (img) img.style.opacity = 0; // il poster lascia il posto al glow live
        } catch (err) {
            // sorgente non campionabile: resta il glow dell'immagine
        }
    }, 3000);

    // rimuove dal registro gli hero non più nel DOM (home smontata):
    // niente observer né riferimenti appesi a nodi morti
    function prune() {
        heroes = heroes.filter(function (r) {
            if (document.body.contains(r)) return true;
            try { observer.unobserve(r); } catch (e) {}
            if (currentRoot === r) currentRoot = null;
            return false;
        });
    }

    return { register: register, bindSlider: bindSlider, toggleMute: toggleMute, replay: replay, prune: prune, isMuted: function () { return muted; } };
})();

// Hook chiamata dal core (navigateToPage) PRIMA di smontare la home:
// chiude la preview on-hover e ripulisce il registro degli hero.
function tyWebHomeTeardown() {
    try { TyPeek.close(); } catch (e) {}
    // gli hero verranno rimossi dal DOM subito dopo: il prune al tick
    // successivo trova i nodi staccati e li scarta
    setTimeout(function () {
        try { TyHero.prune(); } catch (e) {}
    }, 0);
}

/* ------------------------------------------------------------------ *
 * Hero renderer
 * ------------------------------------------------------------------ */

// compat nomi campo (stessa normalizzazione del nativo)
function tyWebHeroNormalize(res) {
    if (res.image_background) res.img_preview_background = res.image_background;
    if (res.image) res.img_preview = res.image;
    if (res.image_logo_title) res.img_preview_logo_title = res.image_logo_title;
    return res;
}

function tyWebHeroHtml(res) {
    res = tyWebHeroNormalize(res);

    // background se c'e', altrimenti la preview: stessa regola ovunque,
    // desktop e mobile (mai la locandina verticale)
    var backdrop = res.img_preview_background || res.img_preview || '';
    var logo = res.img_preview_logo_title || '';
    var title = getCurrentStringML(res.title, currentLang) || '';
    var desc = '';
    try {
        desc = $('<div>').html(getCurrentStringML(res.description, currentLang) || '').text();
    } catch (e) {}

    var meta = '';
    try { meta = generateCollectionInfo(res) || ''; } catch (e) {}

    var reminder = (res.saved == true)
        ? "<i class='ri-check-line'></i><span class='ty-hero-btn-label'>" + translate('SAVED') + "</span>"
        : "<i class='ri-add-line'></i><span class='ty-hero-btn-label'>" + translate('REMIND_ME') + "</span>";

    var playBtn = '';
    if (res.next_video_play && res.next_video_play.id) {
        // openWatchNowFromHome (home.js): sul nativo intercetta l'utente
        // guest e apre il modale di login, sul web va dritto al player
        var playCall = (typeof openWatchNowFromHome === 'function')
            ? 'openWatchNowFromHome(' + res.next_video_play.id + ');'
            : 'loadPageVideo(' + res.next_video_play.id + ');';
        playBtn = '<span class="ty-hero-btn ty-hero-btn-play" onclick="event.stopPropagation();' + playCall + '"><i class="ri-play-fill"></i> ' + translate('WATCH_NOW') + '</span>';
    }

    return '' +
    '<div class="ty-hero" data-trailer="' + (res.trailer || '') + '" data-backdrop="' + backdrop + '" onclick="openSerieThumb(' + res.id + ');">' +
        '<div class="ty-hero-media">' +
            '<img class="ty-hero-backdrop" src="' + backdrop + '" onerror="this.onerror=null;this.src=\'img/void1px.png\';" alt="">' +
        '</div>' +
        '<div class="ty-hero-scrim"></div>' +
        '<div class="ty-hero-info">' +
            (logo
                ? '<img class="ty-hero-logo collectionLogoTitle" src="' + logo + '" onerror="this.remove();" alt="">'
                : '<h1 class="ty-hero-title">' + title + '</h1>') +
            (meta ? '<div class="ty-hero-meta">' + meta + '</div>' : '') +
            (desc ? '<p class="ty-hero-desc">' + desc + '</p>' : '') +
            '<div class="ty-hero-actions">' +
                playBtn +
                '<span class="ty-hero-btn ty-hero-btn-soft controlSetLikeSerie reminder_serie' + res.id + '" onclick="event.stopPropagation();openModalSetSavedContent(' + res.id + ',\'serie\');">' + reminder + '</span>' +
                '<span class="ty-hero-btn ty-hero-btn-soft ty-hero-btn-info" onclick="event.stopPropagation();openSerieThumb(' + res.id + ');"><i class="ri-information-line"></i></span>' +
            '</div>' +
        '</div>' +
        (res.trailer
            ? '<div class="ty-hero-controls">' +
                '<span class="ty-hero-ctrl ty-hero-replay" title="Replay" onclick="event.stopPropagation();TyHero.replay(this);"><i class="ri-restart-line"></i></span>' +
                '<span class="ty-hero-ctrl ty-hero-vol controlTrailerPreviewVideoVolume" onclick="event.stopPropagation();TyHero.toggleMute(this);"><i class="ri-volume-mute-fill"></i></span>' +
            '</div>'
            : '') +
    '</div>';
}

// strati del cinema-light dietro la card (immagine + doppio canvas)
function tyWebHeroGlowHtml(res) {
    res = tyWebHeroNormalize(res || {});
    var backdrop = res.img_preview_background || res.img_preview || '';
    return '<img class="ty-hero-glow" src="' + backdrop + '" onerror="this.remove();" alt="">' +
        '<canvas class="ty-hero-glow-canvas" width="48" height="27" style="opacity:0;"></canvas>' +
        '<canvas class="ty-hero-glow-canvas" width="48" height="27" style="opacity:0;"></canvas>';
}

// renderer sezione hero (slideshow multi-slide o spotlight singolo);
// chiamato dal dispatcher di web-home.js su desktop
function tyWebHeroSection(json, i) {
    var $pos = $('#positionSection' + i);
    $pos.html('');
    var topClass = (i == 1) ? ' ty-hero-first' : '';

    if (json.type == 'collection_spotlight') {
        if (!json.val || json.val.id == '') return;
        $.ajax({
            localCache: true,
            cacheTTL: 1,
            type: 'GET',
            url: URL_API2 + '/collections/' + json.val.id,
            success: function (result) {
                var res;
                try { res = JSON.parse(result); } catch (e) { return; }
                $pos.html('<div class="ty-hero-wrap' + topClass + '">' + tyWebHeroGlowHtml(res) + tyWebHeroHtml(res) + '</div>');
                $pos.find('.ty-hero').each(function () { TyHero.register(this); });
            }
        });
        return;
    }

    // header_slideshow_serie / header_slideshow_pack: stesso endpoint del nativo
    $.ajax({
        type: 'GET',
        localCache: true,
        cacheTTL: 0.5,
        cacheKey: 'ty-hero-images-v2:' + json.endpoint,
        url: json.endpoint,
        success: function (responseSeries) {
            var list;
            try { list = JSON.parse(responseSeries).contents; } catch (e) { return; }
            if (!Array.isArray(list) || list.length === 0) { $pos.remove(); return; }

            var slides = '';
            list.forEach(function (res) {
                slides += '<li class="ty-hero-slide">' + tyWebHeroHtml(res) + '</li>';
            });

            var indicators = '';
            list.forEach(function (_, z) {
                indicators += '<button' + (z === 0 ? ' class="active"' : '') + '></button>';
            });

            var autoplayClass = '';
            var autoplayAttr = '';
            if (json.val && json.val.autoplay == 'true') {
                autoplayClass = ' slider-nav-autoplay slider-nav-autopause';
                autoplayAttr = ' data-slider-nav-autoplay-interval="7000"';
            }

            $pos.html(
                '<div class="ty-hero-wrap ty-hero-slider' + topClass + '">' +
                    tyWebHeroGlowHtml(list[0]) +
                    '<div class="swiffy-slider slider-item-snapstart slider-nav-sm slider-nav-autohide slider-indicators-round slider-indicators-sm' + autoplayClass + '"' + autoplayAttr + '>' +
                        '<ul class="slider-container">' + slides + '</ul>' +
                        '<button type="button" class="slider-nav" aria-label="Previous"></button>' +
                        '<button type="button" class="slider-nav slider-nav-next" aria-label="Next"></button>' +
                        '<div class="slider-indicators">' + indicators + '</div>' +
                    '</div>' +
                '</div>'
            );

            var sliderEl = $pos.find('.swiffy-slider')[0];
            try { swiffyslider.initSlider(sliderEl); } catch (e) {}
            $pos.find('.ty-hero').each(function () { TyHero.register(this); });
            TyHero.bindSlider(sliderEl);
        }
    });
}

/* ------------------------------------------------------------------ *
 * TyPeek — preview on-hover delle card collection (rail della home).
 * Solo desktop con puntatore. Id ricavato dall'onclick della card
 * (openSerieThumb(ID)); dati da /v2/collections/{id} con cache.
 * ------------------------------------------------------------------ */
var TyPeek = (function () {
    var HOVER_DELAY = 600;
    var timer = null;
    var closeTimer = null;
    var currentId = null;
    var $peek = null;

    function enabled() {
        return window.innerWidth >= 992 && window.matchMedia('(pointer: fine)').matches;
    }

    function el() {
        if ($peek) return $peek;
        $peek = $('<div id="ty-peek" style="display:none;"></div>').appendTo('body');
        $peek.on('mouseenter', function () { clearTimeout(closeTimer); });
        $peek.on('mouseleave', scheduleClose);
        return $peek;
    }

    function close() {
        clearTimeout(timer);
        currentId = null;
        if ($peek) { $peek.hide().html(''); }
    }

    function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 180);
    }

    function open(id, rect) {
        currentId = id;
        $.ajax({
            localCache: true,
            cacheTTL: 5,
            type: 'GET',
            url: URL_API2 + '/collections/' + id,
            success: function (result) {
                if (currentId !== id) return;
                var res;
                try { res = tyWebHeroNormalize(JSON.parse(result)); } catch (e) { return; }

                var img = res.img_preview_background || res.img_preview || '';
                var title = getCurrentStringML(res.title, currentLang) || '';
                var logo = res.img_preview_logo_title || '';
                var meta = '';
                try { meta = generateCollectionInfo(res) || ''; } catch (e) {}
                var reminder = (res.saved == true)
                    ? "<i class='ri-check-line'></i>"
                    : "<i class='ri-add-line'></i>";
                var playBtn = (res.next_video_play && res.next_video_play.id)
                    ? '<span class="ty-peek-btn ty-peek-btn-play" onclick="event.stopPropagation();loadPageVideo(' + res.next_video_play.id + ');"><i class="ri-play-fill"></i></span>'
                    : '';

                var width = Math.max(340, Math.min(420, rect.width * 1.5));
                var left = Math.round(rect.left + rect.width / 2 - width / 2);
                left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
                var top = Math.round(rect.top - 28);
                top = Math.max(76, top);

                el().html(
                    '<div class="ty-peek-card" onclick="openSerieThumb(' + res.id + ');">' +
                        '<div class="ty-peek-media">' +
                            '<img src="' + img + '" onerror="this.onerror=null;this.src=\'img/void1px.png\';" alt="">' +
                            (logo ? '<img class="ty-peek-logo" src="' + logo + '" onerror="this.remove();" alt="">' : '') +
                        '</div>' +
                        '<div class="ty-peek-body">' +
                            '<div class="ty-peek-actions">' +
                                playBtn +
                                '<span class="ty-peek-btn controlSetLikeSerie reminder_serie' + res.id + '" onclick="event.stopPropagation();openModalSetSavedContent(' + res.id + ',\'serie\');">' + reminder + '</span>' +
                                '<span class="ty-peek-btn" onclick="event.stopPropagation();openSerieThumb(' + res.id + ');"><i class="ri-arrow-down-s-line"></i></span>' +
                                (res.trailer ? '<span class="ty-peek-btn ty-peek-vol" onclick="event.stopPropagation();TyPeek.toggleMute(this);"><i class="ri-volume-mute-fill"></i></span>' : '') +
                            '</div>' +
                            (!logo ? '<p class="ty-peek-title">' + title + '</p>' : '') +
                            (meta ? '<div class="ty-peek-meta">' + meta + '</div>' : '') +
                        '</div>' +
                    '</div>'
                ).css({ width: width + 'px', left: left + 'px', top: top + 'px' }).show();

                // trailer muted dopo un attimo (se c'è)
                if (res.trailer) {
                    setTimeout(function () {
                        if (currentId !== id || !$peek || !$peek.is(':visible')) return;
                        $peek.find('.ty-peek-media').append(
                            '<iframe class="ty-peek-frame" allow="autoplay" scrolling="no" src="' +
                            window.location.origin + '/video/player?w=' + res.trailer +
                            '&muted=on&controls=off&preview=on&auto=on&fillsize=on"></iframe>'
                        );
                    }, 450);
                }
            }
        });
    }

    function toggleMute(btn) {
        try {
            var v = $(btn).closest('.ty-peek-card').find('iframe.ty-peek-frame').contents().find('video')[0];
            if (!v) return;
            v.muted = !v.muted;
            if (!v.muted) { try { v.play(); } catch (e) {} }
            $(btn).html(v.muted ? '<i class="ri-volume-mute-fill"></i>' : '<i class="ri-volume-up-fill"></i>');
        } catch (e) {}
    }

    // delega: card collection dentro le rail della home (mai sugli hero)
    $(document).on('mouseover', '.standardHome [onclick^="openSerieThumb"]', function () {
        if (!enabled()) return;
        if ($(this).closest('.ty-hero, #ty-peek').length) return;
        var card = this;
        var m = String(card.getAttribute('onclick')).match(/openSerieThumb\((\d+)/);
        if (!m) return;
        clearTimeout(closeTimer);
        clearTimeout(timer);
        timer = setTimeout(function () {
            open(m[1], card.getBoundingClientRect());
        }, HOVER_DELAY);
    });
    $(document).on('mouseout', '.standardHome [onclick^="openSerieThumb"]', function () {
        clearTimeout(timer);
        scheduleClose();
    });
    window.addEventListener('scroll', close, { passive: true, capture: true });

    return { toggleMute: toggleMute, close: close };
})();

/* ------------------------------------------------------------------ *
 * Frecce swiffy-slider sulle rail: il markup nativo (pensato per lo
 * swipe touch) non include i bottoni nav — su desktop si iniettano.
 * ------------------------------------------------------------------ */
function tyWebEnsureSliderNavs() {
    if (window.innerWidth < 992) return;
    $('.sectionContainer .swiffy-slider').each(function () {
        var slider = this;
        if (slider.querySelector('.slider-nav')) return;

        // iniettate DOPO initSlider: swiffy non le ha bindate, quindi il
        // click va collegato a mano all'API (swiffyslider.slide)
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'slider-nav';
        prev.setAttribute('aria-label', 'Previous');
        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'slider-nav slider-nav-next';
        next.setAttribute('aria-label', 'Next');

        prev.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            try { swiffyslider.slide(slider, false); } catch (err) {}
        });
        next.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            try { swiffyslider.slide(slider, true); } catch (err) {}
        });

        slider.appendChild(prev);
        slider.appendChild(next);
    });
}

$(function () {
    var container = document.querySelector('.sectionContainer');
    if (!container) return;
    var debounce = null;
    new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(tyWebEnsureSliderNavs, 250);
    }).observe(container, { childList: true, subtree: true });
    tyWebEnsureSliderNavs();
});
